import styled from 'styled-components';
import { ITheme } from '../../styles/theme';

interface TogglerProps {
  theme: ITheme;
  active?: boolean;
}

export const Wrapper = styled.div<{ active: boolean }>`
  width: 40px;
  height: 20px;
  border-radius: 10px;
  ${({ theme, active }: TogglerProps) => `
    background: ${active ? theme.colors.secondary[100] : '#E6E6E6'};
    border: 2px solid ${active ? theme.colors.secondary[100] : '#E6E6E6'};
  `}
  cursor: pointer;
`;

export const Circle = styled.div<{ active: boolean }>`
  width: 18px;
  height: 100%;
  transition: 0.5s;
  background-color: white;
  border-radius: 100%;
  ${({ active }: TogglerProps) => `
  transform: ${active ? 'translateX(100%)' : 'translateX(0)'};
  `}
`;
